<template>
  <div>
    <section v-if="currentSection == 'sign-in'">
      <form
        @submit.prevent="submit"
      >
        <PrimaryInput
          v-model="form.email"
          :validation="$v.form.email"
          placeholder="E-mail"
          :required="true"
          type="email"
          ref="emailInput"
        />

        <PrimaryInput
          v-model="form.password"
          :validation="$v.form.password"
          placeholder="Senha"
          :required="true"
          type="password"
          ref="passwordInput"
        />

        <SecondaryButton
          type="submit"
          :full="true"
          :disabled="$v.form.$invalid"
        >Entrar</SecondaryButton>
      </form>

      <TextLineThrough></TextLineThrough>

      <GoogleSignInButton
        class="mb-3"
        @click="googleLogin"
      />

      <FacebookSignInButton
        class="mb-3"
        @click="facebookLogin"
      />
      <div class="forgot-password">
        <button
          type="button"
          class="forgot-password-link"
          @click="currentSection = 'reset-password'"
        >Esqueceu sua senha?</button>
      </div>
    </section>

    <section
      v-if="currentSection == 'reset-password'"
    >
      <form
        @submit.prevent="submitResetPassword"
      >
        <div v-if="!hasSuccess">
          <SecondaryButton
            v-model="resetPasswordEmail"
            :validation="$v.resetPasswordEmail"
            placeholder="E-mail vinculado à conta"
            :required="true"
            type="email"
            ref="resetPasswordInput"
          />

          <div class="form-group">
            <PrimaryButton
              type="submit"
              :full="true"
              :disabled="$v.resetPasswordEmail.$invalid"
            >RECUPERAR SENHA</PrimaryButton>
          </div>

          <div class="text-right mt-3">
            <button
              type="button"
              class="forgot-password-link"
              @click="currentSection = 'sign-in'"
            >&lt; voltar</button>
          </div>    
        </div>
      </form>
    </section>
  </div>
</template>

<script>
  import { redirectToPreviousUrl } from '@/utils/redirector'
  import { mapState } from 'vuex'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import PrimaryInput from '@/components/form/PrimaryInput'
  import GoogleSignInButton from '@/components/buttons/GoogleSignInButton'
  import FacebookSignInButton from '@/components/buttons/FacebookSignInButton'
  import authSignInRules from '@/validations/auth/authSignInRules'
  import TextLineThrough from '@/components/text/TextLineThrough'
  import SecondaryButton from '@/components/buttons/SecondaryButton'

  export default {
    components: {
      PrimaryButton,
      SecondaryButton,
      GoogleSignInButton,
      FacebookSignInButton,
      TextLineThrough,
      PrimaryInput
    },

    validations: {
      form: authSignInRules,
      resetPasswordEmail: authSignInRules.email
    },

    data: () => ({
      currentSection: 'sign-in',

      resetPasswordEmail: '',

      form: {
        email: '',
        password: ''
      }
    }),

    mounted () {
      this.$nextTick(() => this.$refs.emailInput.$refs.input.focus())

      if (window.location.hash.includes('#/recuperar-senha')) {
        this.currentSection = 'reset-password'
      }
    },

    computed: {
      ...mapState('auth', ['hasSuccess'])
    },

    watch: {
      currentSection: {
        immediate: true,
        handler (currentSection) {
          this.$v.$reset()

          this.$nextTick(() => {
            if (currentSection == 'reset-password') {
              this.$refs.resetPasswordInput.$refs.input.focus()
            }
          })
        }
      }
    },

    methods: {
      async submit () {
        this.$store.commit('auth/setError', '')

        this.$store.commit('auth/setLoading', true)
        
        const success = await this.$store.dispatch('auth/login', this.form)

        this.$store.commit('auth/setLoading', false)

        if (!success) {
          this.form.password = ''

          this.$refs.passwordInput.$refs.input.focus()
        } else {
          this.$emit('close')

          redirectToPreviousUrl()
        }
      },

      async googleLogin () {
        await this.$store.dispatch('auth/googleLogin')
        this.$emit('close')
      },

      async facebookLogin () {
        const success = await this.$store.dispatch('auth/facebookLogin')
        if (!success) {
          return window.location.reload()
        }
        this.$emit('close')
      },

      async submitResetPassword() {
        const email = this.resetPasswordEmail

        try {
          await this.$store.dispatch('auth/requestResetPassword', email)
        } catch (err) {
          this.resetPasswordEmail = ''
          this.$refs.resetPasswordInput.$refs.input.focus()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.forgot-password {
  text-align: center;
  padding: 16px 8px;
}
</style>